<template lang="pug">
  #informative-dialog.video-step-dialog.is-fullscreen
    .modal-header
      h1 {{ prompt}}
    .modal-row
      .modal-text
        img#informative-image(:src="getMediaUrl(image)")
      .modal-footer
        button.button.cancel-btn(@click="denyHandler") {{ denyBtn }}
        button.button.action-btn(@click="performAction") {{ confirmBtn }}
</template>

<script>
export default {
  props: {
    image: { type: String, required: true },
    prompt: { type: String, required: true },
    confirmBtn: { type: String, required: false, default: 'Yes' },
    denyBtn: { type: String, required: false, default: 'No' },
    denyModal: { type: String, required: false },
    onAction: { type: Function, required: true },
  },

  data() {
    return {
      mediaRootUrl: process.env.VUE_APP_MEDIA_ROOT_URL
    }
  },

  computed: {},

  watch: {},

  created() {},

  methods: {
    close,
    denyHandler,
    performAction,
    getMediaUrl
  },

  components: {},
}

/* Computed ---------------------------------------------------- */
/* Watch ------------------------------------------------------- */
/* Methods ----------------------------------------------------- */
function close() {
  this.$modal.close('InformativeDialog')
}

function denyHandler() {
  if (this.denyModal) {
    this.$modal.open(this.denyModal)
  } else {
    this.close()
  }
}

function performAction() {
  this.onAction()
  this.close()
}

function getMediaUrl(mediaFile) {
  return `${this.mediaRootUrl}${mediaFile}`
}
</script>
